import React, { useState } from "react";
import ReactDOMServer from "react-dom/server";
import { signal } from "@preact/signals-react";

import * as Icons from "components/Icons";
import { Alert } from "components/Alerts/Alert";

const showAlert = signal({
  show: false,
  text: "",
  icon: "check",
  position: "fixed bottom-0 right-0",
  color: "bg-green-200",
  className: "rounded-b-md",
  autoRemove: true,
});

const MenuIcons = ({ handleSelect }) => {
  const [search, setSearch] = useState("");
  const iconNames = Object.keys(Icons);

  const filteredIcons = iconNames.filter((name) =>
    name.toLowerCase().includes(search.toLowerCase()),
  );

  const clickCopy = (icon) => {
    navigator.clipboard
      .writeText(icon)
      .then(() => {
        console.log("Copiado al portapapeles:", icon);
      })
      .catch((err) => {
        console.error("Error al copiar al portapapeles:", err);
      });
    showAlert.value = {
      ...showAlert.value,
      show: true,
      text: `Icono ${icon} copiado correctamente.`,
    };

    handleSelect(icon);
  };

  const downloadSvg = (IconComponent, name) => {
    showAlert.value = {
      ...showAlert.value,
      show: true,
      text: `Preparando descarga de ${name}.`,
    };
    const svgString = ReactDOMServer.renderToStaticMarkup(<IconComponent />);
    const fullSvg = `<?xml version="1.0" encoding="UTF-8"?>\n${svgString}`;
    const blob = new Blob([fullSvg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.svg`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="container mx-auto py-3">
      <div className="mb-6 max-w-2xl mx-auto p-5 bg-gray-100 rounded-lg shadow-md flex flex-wrap items-center space-x-5">
        <input
          type="text"
          placeholder="Buscar icono..."
          className="w-[70%] p-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring focus:border-blue-300 bg-white"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="w-fit font-normal text-base text-gray-500">
          <span className="bold text-green-900">{filteredIcons.length}</span>{" "}
          Iconos creados
        </div>
      </div>

      <div className="grid grid-cols-8 gap-8">
        {filteredIcons.length > 0 ? (
          filteredIcons.map((iconName) => {
            const IconComponent = Icons[iconName];
            return (
              <div
                key={iconName}
                className="group cursor-pointer relative bg-white"
              >
                <div className="relative h-[8.5rem] flex items-center justify-center border border-gray-100 rounded-xl">
                  <IconComponent />
                </div>
                <span className="mt-3 h-10 block truncate text-center text-[0.8125rem] leading-5 text-slate-500">
                  {iconName}
                </span>
                <div className="absolute right-2 top-2 flex space-x-2">
                  <span className="" onClick={() => clickCopy(iconName)}>
                    <Icons.CopyIcon className="w-6 h-6 text-blue-400 hover:text-green-950 fill-current" />
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation(); // Evita que se dispare handleSelect
                      downloadSvg(IconComponent, iconName);
                    }}
                  >
                    <Icons.DonwloadIcon className="w-6 h-6 text-green-500 hover:text-green-950 fill-current" />
                  </span>
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-span-8 text-center text-gray-500">
            No se encontraron íconos.
          </div>
        )}

        <Alert
          {...showAlert.value}
          onClose={() =>
            (showAlert.value = { ...showAlert.value, show: false })
          }
        />
      </div>
    </div>
  );
};

export default MenuIcons;
